export default __webpack_public_path__ + "static/media/logo.5185d5e6.webp";